<script setup lang="ts">
import { computed } from 'vue'

/** "Anna Meier" → "AM"; falls back to the first letter of an email. */
function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return (parts[0] ?? '?').slice(0, 2).toUpperCase()
  return `${parts[0]?.[0] ?? ''}${parts[parts.length - 1]?.[0] ?? ''}`.toUpperCase()
}

const props = withDefaults(defineProps<{ name: string; src?: string; size?: number }>(), { size: 32 })

const initials = computed(() => initialsOf(props.name))
const sizing = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.max(10, Math.round(props.size * 0.36))}px`,
}))
</script>

<template>
  <span class="avatar" :style="sizing" aria-hidden="true">
    <img v-if="src" :src="src" alt="" class="image" />
    <template v-else>{{ initials }}</template>
  </span>
</template>

<style scoped>
.avatar {
  display: grid;
  place-items: center;
  flex: none;
  font-weight: var(--weight-semibold);
  letter-spacing: 0;
  line-height: 1;
  color: var(--color-accent-contrast);
  background-image: linear-gradient(140deg, var(--rv-teal-500), var(--rv-navy-800));
  border-radius: var(--radius-full);
  overflow: hidden;
  user-select: none;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
